import { Icon } from './Icon';

// TODO: in v9, move styled() from Icon.jsx to here
export var StyledIcon = Icon;